/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewAttributesItem
 */
export interface CRSFSecReviewAttributesItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    AdobeTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    CDimensions?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    CGoals?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    CMetrics?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    Followers?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    GTMTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    MJRank?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    MJTLDRank?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    ProductCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    QubitTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    RefIP?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    RefSN?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    Sitemap?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAttributesItem
     */
    TealiumTags?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewAttributesItem interface.
 */
export function instanceOfCRSFSecReviewAttributesItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewAttributesItemFromJSON(json: any): CRSFSecReviewAttributesItem {
    return CRSFSecReviewAttributesItemFromJSONTyped(json, false);
}

export function CRSFSecReviewAttributesItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewAttributesItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'AdobeTags': !exists(json, 'AdobeTags') ? undefined : json['AdobeTags'],
        'CDimensions': !exists(json, 'CDimensions') ? undefined : json['CDimensions'],
        'CGoals': !exists(json, 'CGoals') ? undefined : json['CGoals'],
        'CMetrics': !exists(json, 'CMetrics') ? undefined : json['CMetrics'],
        'Followers': !exists(json, 'Followers') ? undefined : json['Followers'],
        'GTMTags': !exists(json, 'GTMTags') ? undefined : json['GTMTags'],
        'MJRank': !exists(json, 'MJRank') ? undefined : json['MJRank'],
        'MJTLDRank': !exists(json, 'MJTLDRank') ? undefined : json['MJTLDRank'],
        'ProductCount': !exists(json, 'ProductCount') ? undefined : json['ProductCount'],
        'QubitTags': !exists(json, 'QubitTags') ? undefined : json['QubitTags'],
        'RefIP': !exists(json, 'RefIP') ? undefined : json['RefIP'],
        'RefSN': !exists(json, 'RefSN') ? undefined : json['RefSN'],
        'Sitemap': !exists(json, 'Sitemap') ? undefined : json['Sitemap'],
        'TealiumTags': !exists(json, 'TealiumTags') ? undefined : json['TealiumTags'],
    };
}

export function CRSFSecReviewAttributesItemToJSON(value?: CRSFSecReviewAttributesItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AdobeTags': value.AdobeTags,
        'CDimensions': value.CDimensions,
        'CGoals': value.CGoals,
        'CMetrics': value.CMetrics,
        'Followers': value.Followers,
        'GTMTags': value.GTMTags,
        'MJRank': value.MJRank,
        'MJTLDRank': value.MJTLDRank,
        'ProductCount': value.ProductCount,
        'QubitTags': value.QubitTags,
        'RefIP': value.RefIP,
        'RefSN': value.RefSN,
        'Sitemap': value.Sitemap,
        'TealiumTags': value.TealiumTags,
    };
}

